// Generated by CoffeeScript 2.7.0
var MessageGroupModel, MessageGroupsModal, editing_list_item_comp, icon_picker_comp, message_groups_comp, modal_comp, popover_comp;

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import {
  EditingListItemMixin,
  EditingListItem
} from 'trunks/vue/admin/components/editing_list_item.js';

import IconPicker from 'trunks/vue/admin/components/icon_color_picker.js';

editing_list_item_comp = EditingListItem;

modal_comp = Modal;

icon_picker_comp = IconPicker;

popover_comp = Popover;

MessageGroupModel = Skylark.App.Model.MessageGroup;

message_groups_comp = {
  components: {
    'editing-list-item': editing_list_item_comp,
    'icon-picker': icon_picker_comp,
    'popover': popover_comp
  },
  props: {
    messageGroup: {
      type: Skylark.App.BaseModel
    }
  },
  mixins: [EditingListItemMixin],
  template: `<editing-list-item itemClass='message-group'
                   :item='messageGroup'
                   :editingVm='editingVm'
                   inputPlaceholder='请输入分组名称'
                   ref='editingListItemRef'
                   @inputChanged='inputChangedFunc'
                   @destroyed='destroyedFunc'
                   @editingVmChanged='editingVmChangedFunc'
                   @addNewItem='addNewItemFunc'>
  <template slot='tip-template' slot-scope='{ editing, item }'>
    <i v-show='!editing' class='icon' :class='item.icon'></i>
    <popover v-show='editing'
             :caret='false'
             customClass='icon-picker-popover'
             position='bottom left'
             ref='iconPickerPopover'>
      <template slot='trigger'>
        <span class='btn icon-btn btn-small'>
          <i class='editing' :class='item.icon'></i>
        </span>
      </template>
      <template slot='content'>
        <icon-picker pickerMode='icon'
                     :pickedIcon='item.icon'
                     :iconGroupLength='7'
                     @iconChanged='changeIconFunc' />
      </template>
    </popover>
  </template>
</editing-list-item>`,
  methods: {
    inputChangedFunc: function(value) {
      return this.messageGroup.name = value;
    },
    destroyedFunc: function() {
      return newConfirm({
        title: '删除分组',
        message: '同时删除消息的分组',
        confirmButtonText: '我知道了',
        type: 'danger'
      }).$on('ensureClicked', () => {
        return this.messageGroup.destroy();
      });
    },
    changeIconFunc: function(icon) {
      this.messageGroup.name = this.$refs.editingListItemRef.getInputValue();
      this.messageGroup.icon = icon;
      return this.$nextTick(function() {
        this.$refs.iconPickerPopover.close();
        return this.$refs.editingListItemRef.edit();
      });
    }
  }
};

export default MessageGroupsModal = Vue.extend({
  components: {
    'modal': modal_comp,
    'message-group': message_groups_comp
  },
  props: {
    rawMessageGroups: Array,
    updateUrl: String
  },
  data: function() {
    return {
      messageGroups: _.map(this.rawMessageGroups, function(group) {
        return new MessageGroupModel(group);
      }),
      editingVm: null,
      extendClass: ['message-groups-modal', 'large-modal']
    };
  },
  template: `<modal title='分组管理'
       :extendClass='extendClass'
       :backdrop='true'
       ensureText='保存'
       ref='modal'
       @ensureClicked='submit'>
  <div class='sticky-wrapper'>
    <div class='sticky-content'>
      <div class='new-message-group-btn vertical-middle' @click='newMessageGroupFunc'>
        <i class='slp-plus'></i>
        <span>新建分组</span>
      </div>
    </div>
    <div class='scroll-container'>
      <div v-if='_.isEmpty(this.filterMessageGroups)' class='blankslate'>
        <p>没有“分组”</p>
      </div>
      <div v-else class='message-groups list'>
        <message-group v-for='messageGroup in this.filterMessageGroups'
                   :key='messageGroup.uuid'
                   :messageGroup='messageGroup'
                   :editingVm='editingVm'
                   @editingVmChanged='updateEditingVmFunc'
                   @addNewItem='newMessageGroupFunc'/>
      </div>
    </div>
  </div>
</modal>`,
  computed: {
    filterMessageGroups: function() {
      return _.filter(this.messageGroups, function(group) {
        return !group._destroy;
      });
    }
  },
  watch: {
    editingVm: function(val, oldVal) {
      return this.extendClass = _.isEmpty(val) ? ['message-groups-modal', 'large-modal'] : ['message-groups-modal', 'large-modal', 'editing'];
    }
  },
  methods: {
    newMessageGroupFunc: function() {
      if (_.isEmpty(this.editingVm)) {
        return this.messageGroups.push(new MessageGroupModel());
      }
    },
    updateEditingVmFunc: function(vm) {
      return this.editingVm = vm;
    },
    toJSON: function() {
      if (this.editingVm) {
        this.editingVm.update();
      }
      return _.chain(this.messageGroups).filter(function(group) {
        return group.isPersisted() || !group._destroy;
      }).map(function(group) {
        return group.toJSON();
      }).value();
    },
    submit: function() {
      return Skylark.Libs.Ajax.put(this.updateUrl, {
        responseType: 'script',
        contentType: "application/json; charset=UTF-8",
        data: {
          message_groups: this.toJSON()
        },
        success: function() {
          return newAlertify('保存成功', {
            type: 'success'
          });
        },
          error: function() {
          return newAlertify('消息分组更新失败', {
            type: 'danger'
          });
        }
      });
    }
  }
});
